import { render, staticRenderFns } from "./CoinFeed.vue?vue&type=template&id=77190ee7&scoped=true&"
import script from "./CoinFeed.vue?vue&type=script&lang=ts&"
export * from "./CoinFeed.vue?vue&type=script&lang=ts&"
import style0 from "./coin_feed.scss?vue&type=style&index=0&id=77190ee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77190ee7",
  null
  
)

export default component.exports